import React, { useEffect, useState } from "react";
import { Box, CssBaseline, Grid } from "@mui/material";
import { mainLayoutStyles, showNotification } from "../../../../../constants";
import { UserProfileTopFieldsSection } from "../../components/components";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import UserProfileBottomFieldsSection from "../../components/UserProfileBottomFiledsSection/UserProfileBottomFiledsSection";
import DetailsPageHeader from "../../../../../common/DetailsPageHeader";
import { useAuth } from "../../../../../hooks";
import { Toast } from "../../../../../common/alert";
import { useContributorsContext } from "../../../../../providers/OrganizationAdmin/ContributorsProvider";
import {
  updateAdmin,
  uploadAdminImageToStorage,
} from "../../../../../modules/Admins/hooks/AdminsHook";
import {
  getAuth,
  updatePassword as updateFirebasePassword,
  updatePassword,
} from "firebase/auth";
import ImagePreviewModal from "../../../../../common/ImagePreviewModal";

const UserProfileContaner = () => {
  const { setLoading, loading } = useContributorsContext();
  const { currentUser } = useAuth();
  const [editEnabled, setEditEnabled] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [userData, setUserData] = useState(null);
  const [imagePreviewModal, setImagePreviewModal] = useState(false);
  const [uploadImage, setUploadImage] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  console.log("userData", userData);
  // console.log("currentUser", currentUser);

  useEffect(() => {
    if (currentUser) {
      setUserData(currentUser);
    }
  }, [currentUser]);

  const handleImagePreviewModalOpen = () => {
    setImagePreviewModal(true);
  };
  const handleImagePreviewModalClose = () => {
    setImagePreviewModal(false);
    setSelectedImage(null);
  };

  const handleUpdateProfile = async () => {
    try {
      setLoading(true);
      // Construct the updated user data
      const updatedUserData = {
        firstName: userData?.firstName ?? "",
        lastName: userData?.lastName ?? "",
      };

      // if (currentUser?.firstName !== userData?.firstName) {
      //   updatedUserData.firstName = userData?.firstName;
      // }
      // if (currentUser?.lastName !== userData?.lastName) {
      //   updatedUserData.lastName = userData?.lastName;
      // }

      if (uploadImage != null) {
        let photoUrl = await uploadAdminImageToStorage(uploadImage.raw);
        updatedUserData.photoUrl = photoUrl;
      }

      await updateAdmin(currentUser.id, updatedUserData);
      if (newPassword !== "") {
        const auth = getAuth();
        const user = auth.currentUser;
        await updatePassword(user, newPassword);
      }
      // Update local userData state with the updated data
      setUserData({ ...userData, ...updatedUserData });
      setEditEnabled(false);

      showNotification("User updated successfully");
      // Toast("success", "User updated successfully");
    } catch (error) {
      Toast("error", `Error updating user: ${error.message}`);
      console.error("Error updating user:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <DetailsPageHeader
        mainTitle={"Admin User Profile"}
        bgColor="#fff"
        buttonText={"Edit"}
        editEnabled={editEnabled}
        setEditEnabled={setEditEnabled}
        cancelButton={editEnabled ? true : false}
        handleSave={() => handleUpdateProfile()}
        loading={loading}
      />

      <GeneralAdminSidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff", margin: 40 }}>
        <Grid container direction={"column"}>
          <UserProfileTopFieldsSection
            userData={userData}
            setUserData={setUserData}
            currentUser={currentUser}
            handleImagePreviewModalOpen={handleImagePreviewModalOpen}
            editEnabled={editEnabled}
            uploadImage={uploadImage}
            setUploadImage={setUploadImage}
            setEditEnabled={setEditEnabled}
            newPassword={newPassword}
            setNewPassword={setNewPassword}
          />
          <UserProfileBottomFieldsSection
            userData={userData}
            setUserData={setUserData}
            editEnabled={editEnabled}
            setEditEnabled={setEditEnabled}
          />
        </Grid>
      </Grid>
      <ImagePreviewModal
        modalOpen={imagePreviewModal}
        handleClose={handleImagePreviewModalClose}
        image={
          uploadImage != null && uploadImage.preview
            ? uploadImage.preview
            : userData?.photoUrl
        }
      />
    </Box>
  );
};

export default UserProfileContaner;
